import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoginTemplate, MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer } from "@/design-system/Organisms";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";
import { useAuthService } from "@/rtkQuery/features/hooks";
import { ROUTES } from "@/routes/routes.config";

const Login = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthService();

  useScrollToTopOnMount();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTES.HOME, { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <MainLayout
      header={<Header {...headerConfig} />}
      sidebar={null}
      className=""
      footer={<Footer />}
    >
      <LoginTemplate />
    </MainLayout>
  );
};

export default Login;
